<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{title}}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="门店汇总" name="distributionSum">
        <search-form-template
          :searchOptions="distributionSumSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(1)"
        ></search-form-template>
        <table-template
          ref="distributionSum"
          :tableOptions="distributionTable">
        </table-template>
      </el-tab-pane>

      <el-tab-pane label="商品汇总" name="commoditySum">
        <search-form-template
          :searchOptions="commodityTableSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(2)"
        ></search-form-template>
        <table-template
          ref="commoditySum"
          :tableOptions="commodityTable">
        </table-template>
      </el-tab-pane>

      <el-tab-pane label="调拨明细" name="distributionDetailed">
        <search-form-template
          :searchOptions="distributionDetailedTableSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(3)"
        ></search-form-template>
        <table-template
          ref="distributionDetailed"
          :tableOptions="distributionDetailedTable">
        </table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import api from '@/config/api';

  export default {
    data() {
      return {
        activeTab: 'distributionSum',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },
        // 配送汇总高级查询
        distributionSumSearchOptions: {
          simple: [
            //   {
            //   label: '调出门店',
            //   prop: 'distributionStoreName',
            //   type: 'input',
            //   isFuzzy: true,
            //   placeholder: '请输入调出门店'
            // }
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            // {
            //   label: '配送级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   span: 12,
            //   change: this.selectLevel,
            // },
            {
              label: '调出门店',
              type: 'select',
              prop: 'distributionStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'receivingStoreId',
              data: [], span: 12,
              isHasAll: true,
              url: api.system.seStore,
              // hidden: this.$utils.getSysUser().storeId === null ? false : true,
            }]
        },
        //商品汇总高级查询
        commodityTableSearchOptions: {
          simple: [
            // {label: '配送门店', prop: 'distributionStoreName', type: 'input', isFuzzy: true, placeholder: '请输入配送门店'},
            {label: '商品名称', prop: 'goodsName', type: 'input', isFuzzy: true, placeholder: '请输入条码/品名/自编码'}],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            // {
            //   label: '配送级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   span: 12,
            //   change: this.selectGoodsLevel,
            // },
            {
              label: '调出门店',
              type: 'select',
              prop: 'distributionStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'receivingStoreId',
              data: [], span: 12,
              isHasAll: true,
              url: api.system.seStore,
              // hidden: this.$utils.getSysUser().storeId === null ? false : true,
            }]
        },
        //配送明细高级查询
        distributionDetailedTableSearchOptions: {
          simple: [
            {label: '条码/品名/自编码', labelWidth: '150px', prop: 'barCode', type: 'input', placeholder: '请输入条码/品名/自编码'},
          ],
          // {label: '', prop: 'goodsName', type: 'input', isFuzzy: true, placeholder: '货号/商品名称'}],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            // {
            //   label: '配送级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   span: 12,
            //   change: this.selectDetailedLevel
            // },
            {
              label: '调出门店',
              type: 'select',
              prop: 'distributionStoreId',
              data: [],
              isHasAll: true,
              span: 8,
              url: api.system.seStore,
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'receivingStoreId',
              data: [],
              span: 8,
              isHasAll: true,
              url: api.system.seStore,
              // hidden: this.$utils.getSysUser().storeId === null ? false : true,
              // change: this.storeChange
            },
            {label: '调入/调出单号', prop: 'orderNo', type: 'input', isFuzzy: true, placeholder: '请输入调入/调出单号'}
            // {
            //   label: '品牌',
            //   type: 'select',
            //   prop: 'goodsBrandId',
            //   data: [],
            //   span: 8,
            //   //url: api.archives.brand
            // },
            // {
            //   label: '供应商',
            //   type: 'select',
            //   prop: 'supplierId',
            //   data: [],
            //   span: 8,
            //   //url: api.archives.supplier
            // },
            // {
            //   label: '类别',
            //   type: 'cascaderMultiple',
            //   prop: 'goodsCategoryIds',
            //   valueKey: 'value',
            //   data: [],
            //   span: 8,
            //   change: this.typeChange,
            //   url: api.archives.getCategoryTree,
            // },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print',
            callback: this.print
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          }
        ],
        // 配送汇总表格信息配置
        distributionTable: {
          // height:32*12+3,
          showSummary: true,
          summaryColumns: ['distributionMoney', 'receivingMoney', 'differentMoney', 'distributionNum', 'receivingNum', 'differentNum'],
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '调出门店',
              prop: 'distributionStoreName',
              width: '150',
              align: 'center'
            },
            {
              label: '调入门店',
              prop: 'receivingStoreName',
              width: '150',
              align: 'center'
            },
            {
              label: '调出数量',
              prop: 'distributionNum',
              width: '120',
              align: 'center',
              //  deal: this.$utils.returnFloat
            },
            {
              label: '调出金额(元)',
              prop: 'distributionMoney',
              width: '120',
              align: 'center',
              //  deal: this.$utils.returnFloat
            },
            {
              label: '调入数量',
              prop: 'receivingNum',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '调入金额(元)',
              prop: 'receivingMoney',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '差异数量',
              prop: 'differentNum',
              width: '120',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '差异金额(元)',
              prop: 'differentMoney',
              width: '120',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
          ],
          url: api.delivery.distributionSummarize
        },
        // 商品汇总表格信息配置
        commodityTable: {
          // height:32*12+3,
          showSummary: true,
          summaryColumns: ['distributionGoodsNum', 'distributionSubtotalAmount', 'receivingGoodsNum', 'receivingSubtotalAmount',
            'differentGoodsNum', 'differentSubtotalAmount'],
          indexShow: true,//是否显示索引,
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '调出门店',
              prop: 'distributionStoreName',
              width: '220',
              align: 'center'
            },
            {
              label: '调入门店',
              prop: 'receivingStoreName',
              width: '220',
              align: 'center'
            },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '180',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '70',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'goodsUnitName',
              width: '70',
              align: 'center'
            },
            {
              label: '调出数量',
              prop: 'distributionGoodsNum',
              width: '120',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '调出金额(元)',
              prop: 'distributionSubtotalAmount',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '调入数量',
              prop: 'receivingGoodsNum',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '调入金额(元)',
              prop: 'receivingSubtotalAmount',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '差异数量',
              prop: 'differentGoodsNum',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            {
              label: '差异金额(元)',
              prop: 'differentSubtotalAmount',
              width: '120',
              align: 'center',
              // deal: this.$utils.returnFloat
            },
            // {
            //   label: '类别编码',
            //   prop: 'categoryCode',
            //   width: '150',
            //   align: 'center'
            // },
            // {
            //   label: '类别',
            //   prop: 'categoryName',
            //   width: '150',
            //   align: 'center'
            // },
          ],
          url: api.delivery.goodsSummarize
        },
        // 配送明细表格信息配置
        distributionDetailedTable: {
          // height:32*12+3,
          showSummary: true,
          summaryColumns: ['distributionGoodsNum', 'distributionSubtotalAmount', 'receivingGoodsNum', 'receivingSubtotalAmount', 'differentNum', 'differentAmount'],
          indexShow: true,//是否显示索引
          param: {
            stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          },
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '调出门店',
              prop: 'distributionStoreName',
              width: '200',
              align: 'center'
            },
            {
              label: '调出单号',
              prop: 'distributionOrderNo',
              width: '240',
              align: 'center',
              callback: this.goDistributionOrderDetail
            },
            {
              label: '调入门店',
              prop: 'receivingStoreName',
              width: '300',
              align: 'center'
            },
            {
              label: '调入单号',
              prop: 'receivingOrderNo',
              width: '240',
              align: 'center',
              callback: this.goReceivingOrderDetail
            },
            // {
            //   label: '类别编码',
            //   prop: 'categoryCode',
            //   width: '150',
            //   align: 'center'
            // },
            // {
            //   label: '类别名称',
            //   prop: 'categoryName',
            //   width: '150',
            //   align: 'center'
            // },
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '150',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '70',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'goodsUnitName',
              width: '70',
              align: 'center'
            },
            // {
            //   label: '供应商',
            //   prop: 'supplierName',
            //   width: '150',
            //   align: 'center'
            // },
            // {
            //   label: '品牌',
            //   prop: 'brandName',
            //   width: '150',
            //   align: 'center'
            // },
            {
              label: '单价',
              prop: 'buyPrice',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '调出数量',
              prop: 'distributionGoodsNum',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '调出金额(元)',
              prop: 'distributionSubtotalAmount',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '调入数量',
              prop: 'receivingGoodsNum',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '调入金额(元)',
              prop: 'receivingSubtotalAmount',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '差异数量',
              prop: 'differentNum',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            },
            {
              label: '差异金额(元)',
              prop: 'differentAmount',
              width: '150',
              align: 'center',
              //deal: this.$utils.returnFloat
            }
          ],
          url: api.delivery.detailedSummarize
        },
        // 调拨详情
        transferringDetailColumns: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              10: '/static/un-check.png',
              20: '/static/checked.png',
            },
            right: '100px',
            top: '0'
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号：',
              prop: 'orderNo',
            }, {
              label: '引用单号：',
              prop: 'requireOrderNo',
            }, {
              label: '调出门店：',
              prop: 'deliverStoreName',
            },
            {
              label: '调出仓库',
              prop: 'deliverWarehouseName',
            },
            {
              label: '调入门店：',
              prop: 'requireStoreName',
            },
            {
              label: '调入仓库',
              prop: 'requireWarehouseName',
            },
            {
              label: '经手人：',
              prop: 'handlerName',
            }, {
              label: '备注：',
              prop: 'remarks',
            }],
          tablesProp: {
            goodsMapMVOList: {
              url: api.delivery.transferringGoods + "/page",
              height: this.detailHeight,
              indexShow: true,
              showSummary: true,
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '150'
                }
              ]
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapMVOList: {
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '90'
                }
              ]
            },
          },
          url: api.delivery.transferringDetails
        },
        //配送详情
        DeliverDetailColumns: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              10: '/static/un-check.png',
              20: '/static/checked.png',
            },
            right: '100px',
            top: '0px'
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号：',
              prop: 'orderNo',
            }, {
              label: '引用单号：',
              prop: 'allocationOrderNo',
            }, {
              label: '配送门店',
              prop: 'distributionStoreName',
            },
            {
              label: '配送仓库',
              prop: 'distributionWarehouseName',
            },
            {
              label: '收货门店',
              prop: 'receivingStoreName',
            },
            {
              label: '收货仓库',
              prop: 'receivingWarehouseName',
            },
            {
              label: '经手人：',
              prop: 'handlerName',
            }],
          tablesProp: {
            goodsMapMVOList: {
              url: api.delivery.deliverGoods + "/page",
              height: this.detailHeight,
              indexShow: true,
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: 'center',
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '差异数量',
                  width: '100',
                  prop: 'differenceNum',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '150'
                }
              ]
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapMVOList: {
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '90'
                }
              ]
            },
          },
          url: api.delivery.deliverDetails
        }
      };
    },
    created() {
      this.title = document.title;
    },
    methods: {
      goDistributionOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.transferringDetailColumns);
        const {href} = this.$router.resolve({
          name: "transferringDetail",
          query: {id: row.distributionId},
        });
        window.open(href, "_blank");
      },
      goReceivingOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.DeliverDetailColumns);
        const {href} = this.$router.resolve({
          name: "deliverDetail",
          query: {id: row.receivingId},
        });
        window.open(href, "_blank");
      },
      tabChange() {
        this.$refs[this.activeTab].operationSuccess();
      },
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      clearSearch() {
        this.$refs['distributionSum'].clearSearch();
        this.$refs['commoditySum'].clearSearch();
        this.$refs['distributionDetailed'].clearSearch();
      },
      selectLevel(data) {
        if (data.relateType === 10) {
          data.distributionStoreId = '';
          this.distributionSumSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = true
        } else {
          this.distributionSumSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = false
        }
      },
      selectDetailedLevel(data) {
        if (data.relateType === 10) {
          data.distributionStoreId = '';
          this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = true
        } else {
          this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = false
        }
      },
      selectGoodsLevel(data) {
        if (data.relateType === 10) {
          data.distributionStoreId = '';
          this.commodityTableSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = true
        } else {
          this.commodityTableSearchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = false
        }
      },
      exportExcel(param) {
        let params, url, fileName;
        if (param === 1) {
          params = this.$refs["distributionSum"].searchParam;
          url = api.delivery.distributionSummarizeExport;
          fileName = '门店汇总_';
        } else if (param === 2) {
          params = this.$refs["commoditySum"].searchParam;
          url = api.delivery.goodsSummarizeExport;
          fileName = '商品汇总_';
        } else if (param === 3) {
          params = this.$refs["distributionDetailed"].searchParam;
          url = api.delivery.detailedSummarizeExport;
          fileName = '调拨明细_';
        } else {
          this.$message.error("未知类型,导出异常");
          return false;
        }
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(url, params).then(res => {
          if (res.status === 200) {
            fileName = fileName + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },

      storeChange(row) {
        //通过收货门店获取相应的供应商以及品牌
        this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = [];
        this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = [];
        row.goodsBrandId = '';
        row.supplierId = '';
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: row.receivingStoreId}).then(data => {
          if (data.code === 200) {
            this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          } else {
            this.$message({message: "请求失败！", type: 'error'});
          }
        });
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: row.receivingStoreId}).then(data => {
          if (data.code === 200) {
            this.distributionDetailedTableSearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          } else {
            this.$message({message: "请求失败！", type: 'error'});
          }
        });
      }
    }
  }
</script>

<style scoped>
  .page-template {
    padding-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/delivery/Query.vue